import { render, staticRenderFns } from "./ValorisationStock.vue?vue&type=template&id=69fe8523&scoped=true&"
import script from "./ValorisationStock.vue?vue&type=script&lang=js&"
export * from "./ValorisationStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69fe8523",
  null
  
)

export default component.exports